import * as angular from "angular";

import template from "./proxy-modal.html";
import "./proxy-modal.less";
import "angular-json-tree/dist/angular-json-tree.css";

import {
	FORM_PROXY_EXECUTE,
	FORM_PROXY_DETAILS
} from "routes";
import viewers from "./viewers";
import markdownToHtmlModule from "../../markdown-viewer";
import jsonSchemaForm from "../../../extensions/json-schema/json-schema-form";

export class Controller {
	constructor(appState, api, loadingService, toastr, $scope) {
		this.appState = appState;
		this.api = api;
		this.toastr = toastr;
		this.loadingService = loadingService;
		this.$scope = $scope;
	}

	$onInit() {
		this.getProxyInfo();

		this.title = this.resolve.title;
		this.description = this.resolve.proxy && this.resolve.proxy.Description ? this.resolve.proxy.Description : "";
		this.model = {};
		this.response = null;
		this.succeeded = false;
		this.executed = false;
	}

	async getProxyInfo() {
		const url = FORM_PROXY_DETAILS(this.appState.forms.selected.Id, this.resolve.proxy.Id);
		try {
			const response = await this.loadingService.watch(this.api.get(url), "Loading proxy info...");
			this.succeeded = !!response.Code;
			this.title = response.Name;
			this.currentProxy = response;
			this.schema = response.Schema;
		}catch(e) {
			this.succeeded = false;
		}
	}

	handleCancel() {
		this.modalInstance.dismiss();
	}

	async handleRun(formController) {
		this.response = null;
		this.executed = false;

		if(!this.validate(formController)) {
			this.toastr.error("Inputs are invalid");
			return;
		}

		const url = FORM_PROXY_EXECUTE(this.appState.forms.selected.Id, this.currentProxy, this.model);
		const verb = this.currentProxy.Method.toLowerCase();
		const payload = verb === "post" ? this.model : undefined;

		try {
			// TODO: response is resp.Data, need to get entire response payload here
			const response = await this.loadingService.watch(this.api[verb](url, payload, {}, true), "Executing proxy...");
			this.response = response.data;
			this.executed = true;
		}catch(e) {
			this.toastr.error("Proxy call failed");
		}
	}

	validate(formController) {
		if(!this.schema) {
			return true;
		}
		if(!formController) {
			return false;
		}

		this.$scope.$broadcast("schemaFormValidate", formController.$name);
		return formController.$valid;
	}
}

export default angular.module("vesl.components.proxy-modal", [
	viewers,
	markdownToHtmlModule,
	jsonSchemaForm
]).component("proxyModal", {
	controller: Controller,
	template,
	bindings: {
		close: "&",
		dismiss: "&",
		modalInstance: "<",
		resolve: "<"
	}
}).name;
